import { PlatformsAcceptanceAction } from './platforms-acceptance.action';
import { InitializerAction } from '../../state-management/initializer/initiliazer.action';

export class PlatformsAcceptanceState {
    public result: boolean
    public message: string;
    public pending: boolean;
}

export const initialState: PlatformsAcceptanceState = {
    result: false,
    message: '',
    pending: true,
};

export function PlatformsAcceptanceReducer(
    state: PlatformsAcceptanceState = initialState,
    action?: PlatformsAcceptanceAction) {

    switch (action.type) {

        case PlatformsAcceptanceAction.getDataTransferAcceptance:
            return { ...{ pending: true } };
        case PlatformsAcceptanceAction.getDataTransferAcceptanceError:
            return { ...{ pending: false, error: action.payload } };
        case PlatformsAcceptanceAction.getDataTransferAcceptanceSuccess:
            return {  ...action.payload, pending: false };

        case PlatformsAcceptanceAction.setDataTransferAcceptance:
            return { ...state, ...{ pending: true } };
        case PlatformsAcceptanceAction.setDataTransferAcceptanceError:
            return { ...state, ...{ pending: false, error: action.payload } };
        case PlatformsAcceptanceAction.setDataTransferAcceptanceSuccess:
            return { ...state, ...{ ...action.payload, pending: false } };
        
            case InitializerAction.resetUserRelatedData:
            return initialState;
        default:
            return state;
    }
}
